const userStorage = localStorage.getItem("currentUser")
  ? JSON.parse(localStorage.getItem("currentUser"))
  : {};

const permissionsStorage = localStorage.getItem("userPermissions")
  ? JSON.parse(localStorage.getItem("userPermissions"))
  : [];

const pmProjectsStorage = JSON.parse(
  localStorage.getItem("pmProjects")
) || [];

const isGlobalAdminStorage = JSON.parse(
  localStorage.getItem("isGlobalAdmin")
) || false;

const projectPermissionsStorage = localStorage.getItem("projectPermissions")
  ? JSON.parse(localStorage.getItem("projectPermissions"))
  : {};


export const initialState = {
  userId: "",
  userName: "",
  fullName: "",
  email: "",
  token: "",
  permissions: [],
  projectPermissions: projectPermissionsStorage, 
  activePermissions: [],
  
  pmProjects: pmProjectsStorage,
  isGlobalAdmin: isGlobalAdminStorage,

  isAdminUser: false,
  isAdminUI: false,
  selectedProject: null,

  loading: false,
};

export const SmarkReducer = (state, action) => {
  switch (action.type) {
    case "REQUEST_LOGIN":
      return { ...state, loading: true };

  case "LOGIN_SUCCESS": {
  const {
    user,
    permissions,
    isAdminUser,
    isAdminUI,
    pmProjects,
    isGlobalAdmin,
    projectPermissions,
  } = action.payload;

  return {
    ...state,
    userId: user.userId,
    userName: user.username,
    fullName: `${user.firstName} ${user.lastName}`,
    email: user.email,
    token: user.idToken || "",

    permissions,

   
    pmProjects: pmProjects || [],
    isGlobalAdmin: !!isGlobalAdmin,

    isAdminUser,
    isAdminUI,
    projectPermissions: projectPermissions || state.projectPermissions,
    loading: false,
  };
}

case "SET_PROJECT_PERMISSIONS": {
  return {
    ...state,
    projectPermissions: action.payload, // { projectId: ["AR", "AF", ...] }
  };
}

    case "SET_SELECTED_PROJECT": {
  const projectId = Number(action.payload);

  const pmProjects = state.pmProjects || [];
  const isAdminUI = state.isGlobalAdmin || pmProjects.includes(projectId);

  const activePermissions =
    state.projectPermissions?.[projectId] || [];

  return {
    ...state,
    selectedProject: projectId,
    isAdminUI,
    activePermissions, 
  };
}


    case "REQUEST_TASK_LIST":
      return {
        ...state,
        taskList: action.payload.taskDetails,
      };

    case "LOGOUT":
      return initialState;

    case "LOGIN_ERROR":
      return { ...state, loading: false, errorMessage: action.error };

    default:
      return state;
  }

  
};
